export const getBrandPath = () => {
  try {
    const arr = window.location.href.split('/');
    return arr[3];
  } catch (error) {
    console.error(error);
    return '';
  }
};

export const getPagePath = () => {
  try {
    const arr = window.location.href.split('/');
    return arr[5];
  } catch (error) {
    console.error(error);
    return '';
  }
};
